import {useTranslation} from "react-i18next";
import React, {useContext, useEffect, useState} from "react";
import InitContext from "../pages/InitContext";
import useMmcService from "../../services/MmcService";
import {Consts} from "../pages/consts";
import Icd10Tree from "./Icd10Tree";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/free-solid-svg-icons";

const Disease = ({
                   showDialog,
                   closeDialog,
                   patientDiseases,
                   onSetPatientDiseases,
                   diseasesToShow,
                   setAlreadyAddedError
                 }) => {
  const {t} = useTranslation();
  const [icd10Data, setIcd10Data] = useState([]);
  const context = useContext(InitContext);
  const {loading, error, clearError, getDiseasesJson} = useMmcService();

  useEffect(() => {
    if (context?.token && context?.token !== "") {
      clearError();

      getDiseasesJson(context?.token).then((data) => {
        setIcd10Data(data);
      });
    }
  }, []);

  const errorMessage = error && (
    <ErrorMessage message={ t("error_by_retrieving_a_list_of_all_diseases") }/>
  );

  const spinner = loading && <Spinner/>;

  return (
    <div>
      <div className="w3-modal" style={ {display: showDialog ? Consts.BLOCK : Consts.NONE} }>
        <div className="w3-modal-content w3-card-4 w3-animate-zoom w3-theme-l3 dialog-wide disease-tree">
          { errorMessage }
          { spinner }
          <header className="feedback-modal-header close-icon-right">
            <FontAwesomeIcon
              icon={faXmark}
              className="modal-close w3-margin-small"
              onClick={closeDialog}
            />
          </header>
          <div className="w3-container w3-padding-small">
            <div className="w3-row">
              <div className="w3-col diseases-scroll">
                <div className="w3-container w3-padding">
                  <Icd10Tree
                    data={ icd10Data }
                    patientDiseases={ patientDiseases }
                    onSetPatientDiseases={ onSetPatientDiseases }
                    closeDialog={ closeDialog }
                    diseasesToShow={ diseasesToShow }
                    setAlreadyAddedError={ (value) => setAlreadyAddedError(value) }
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Disease;
